class CloseSelect {
    [x: string]: any;

    onClose() {
        this.value = null;
        this.onClose();
    }

}
export default {
    controller: CloseSelect,
    template : require('./close.select.html'),
    bindings: {value: '<', onClose: '&'}
};
